import * as _ from 'lodash';

export class CouponStrategy {
  calculateCommission(obj, rootState, rootGetters) {
    const newObject = obj;

    const contracts = rootGetters['customer/getContracts'];
    const isNde = rootGetters.isProductNDE;
    const contract = this.selectContract(contracts, isNde);
    if (!contract) throw new Error('There is no contract for this customer');

    const vatRate = rootState.products.all.products[0].vat;
    const provisionVatRate = rootState.products.all.products[0].provisionVat;
    newObject.commissionItems = this.doTheCalculation(newObject, contract, rootGetters, vatRate, provisionVatRate);
    newObject.commissionItems.contract_id = contract.contract_id;
    return newObject;
  }

  // eslint-disable-next-line consistent-return
  selectContract(contracts, isNde) {
    if (!contracts) return null;

    const individualContract = this.getClientContract(contracts.individual);
    const defaultContract = this.getClientContract(contracts.default);

    if (isNde) {
      return defaultContract || individualContract;
    }

    return individualContract || defaultContract;
  }

  getClientContract = (contracts) => {
    if (!contracts || contracts.length === 0) return null;
    return contracts[0];
  };

  // eslint-disable-next-line class-methods-use-this
  doTheCalculation(total, contract, rootGetters, vatRate, provisionVatRate) {
    const commissionObject = {
      commission: 0,
      has_commission: true,
      delivery_fee: 0,
      card_fee: 0,
      vat: 0,
    };
    const summary = total.summary - total.summaryMrk - total.summaryKonf;

    const minimumCommission = _.round(Number(contract.commissionFixedFee) || 0, 2);
    const commissionRate = Number(contract.commissionPercentageFee) || 0;
    const commissionValue = _.round(summary * (commissionRate / 100), 2);
    commissionObject.commission = summary > 0
      ? Math.max(minimumCommission, commissionValue)
      : 0;
    commissionObject.has_commission = commissionObject.commission > 0;

    commissionObject.delivery_fee = parseFloat(contract.delivery_fee) * rootGetters['cart/getDeliveryNumber'];
    if (parseFloat(contract.delivery_free_quantity) > 0) {
      commissionObject.delivery_fee -= (parseFloat(contract.delivery_free_quantity) * parseFloat(contract.delivery_fee));
    }

    commissionObject.card_fee = total.quantity * parseFloat(contract.card_fee);

    if (vatRate) {
      commissionObject.vat = summary * vatRate;
    } else {
      commissionObject.vat = ((commissionObject.card_fee + commissionObject.delivery_fee + commissionObject.commission + total.summaryMrk + total.summaryKonf) * provisionVatRate);
      commissionObject.vat = _.round(commissionObject.vat, 2);
    }

    commissionObject.commission = _.round(commissionObject.commission, 2);
    return commissionObject;
  }
}
